module.exports = __webpack_public_path__ + "img/choose-gift.ffe07dce.svg";